import ActionConstants from '../constants/actions';

const initialState = {
  isMFAActivated: false,
  isMFAActivatedFetched: false,

  allUsersLoading: false,
  allUsersFetched: false,
  allUsersError: '',
  allUsersResponse: null,

  // Create user flow
  createUserLoading: false,
  createUserFeedback: null, // { type: 'success' | 'error', message? }

  // Edit user flow
  editUserLoading: false,
  editUserFeedback: null, // { type: 'success' | 'error', message? }

  // Fetch user details (for edit pre-population)
  getUserLoading: false,
  getUserData: null,  // Full user object from GET /user/:brandUserId
  getUserError: '',
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){
  switch (action.type) {
    case ActionConstants.UsersConstants.CHECK_IS_MFA_ACTIVATED_INIT : {
      return {
        ...state,
        error:'',
      }
    }
    case ActionConstants.UsersConstants.CHECK_IS_MFA_ACTIVATED_SUCCESS : {
      return {
        ...state,
        isMFAActivated: action.payload,
        isMFAActivatedFetched: true,
      }
    }
    case ActionConstants.UsersConstants.CHECK_IS_MFA_ACTIVATED_ERROR : {
      return {
        ...state,
        isMFAActivated : false,
        error: action.payload,
      }
    }

    case ActionConstants.UsersConstants.GET_ALL_USERS_INIT: {
      return {
        ...state,
        allUsersLoading: true,
        allUsersError: '',
      };
    }
    case ActionConstants.UsersConstants.GET_ALL_USERS_SUCCESS: {
      return {
        ...state,
        allUsersLoading: false,
        allUsersFetched: true,
        allUsersResponse: action.payload,
        allUsersError: '',
      };
    }
    case ActionConstants.UsersConstants.GET_ALL_USERS_ERROR: {
      return {
        ...state,
        allUsersLoading: false,
        allUsersFetched: true,
        allUsersError: action.payload,
      };
    }

    // ── Create user ──────────────────────────────────────────────────────────
    case ActionConstants.UsersConstants.CREATE_USER_LOADING: {
      return {
        ...state,
        createUserLoading: true,
        createUserFeedback: null,
      };
    }
    case ActionConstants.UsersConstants.CREATE_USER_SUCCESS: {
      return {
        ...state,
        createUserLoading: false,
        createUserFeedback: { type: 'success' },
      };
    }
    case ActionConstants.UsersConstants.CREATE_USER_ERROR: {
      return {
        ...state,
        createUserLoading: false,
        createUserFeedback: { type: 'error', message: action.payload },
      };
    }
    case ActionConstants.UsersConstants.CLEAR_CREATE_USER_FEEDBACK: {
      return {
        ...state,
        createUserFeedback: null,
      };
    }

    // ── Edit user ────────────────────────────────────────────────────────────
    case ActionConstants.UsersConstants.EDIT_USER_LOADING: {
      return {
        ...state,
        editUserLoading: true,
        editUserFeedback: null,
      };
    }
    case ActionConstants.UsersConstants.EDIT_USER_SUCCESS: {
      return {
        ...state,
        editUserLoading: false,
        editUserFeedback: { type: 'success' },
      };
    }
    case ActionConstants.UsersConstants.EDIT_USER_ERROR: {
      return {
        ...state,
        editUserLoading: false,
        editUserFeedback: { type: 'error', message: action.payload },
      };
    }
    case ActionConstants.UsersConstants.CLEAR_EDIT_USER_FEEDBACK: {
      return {
        ...state,
        editUserFeedback: null,
      };
    }

    // ── Get user details (edit pre-population) ───────────────────────────────
    case ActionConstants.UsersConstants.GET_USER_LOADING: {
      return {
        ...state,
        getUserLoading: true,
        getUserData: null,
        getUserError: '',
      };
    }
    case ActionConstants.UsersConstants.GET_USER_SUCCESS: {
      return {
        ...state,
        getUserLoading: false,
        getUserData: action.payload,
        getUserError: '',
      };
    }
    case ActionConstants.UsersConstants.GET_USER_ERROR: {
      return {
        ...state,
        getUserLoading: false,
        getUserError: action.payload,
      };
    }
    case ActionConstants.UsersConstants.CLEAR_GET_USER: {
      return {
        ...state,
        getUserLoading: false,
        getUserData: null,
        getUserError: '',
      };
    }

    default:
    return state;
  }
}
